import { FactionsPanel } from '@/components/game/FactionsPanel';

export function FactionsPage() {
  return <FactionsPanel />;
}
